<template>
  <path pid="0" d="M18 2H8a6 6 0 00-6 6v10a6 6 0 006 6h10a6 6 0 006-6V8a6 6 0 00-6-6zm4 16a4 4 0 01-4 4H8a4 4 0 01-4-4V8a4 4 0 014-4h10a4 4 0 014 4z"/><path pid="1" d="M13.78 8A5 5 0 1018 12.22 5 5 0 0013.78 8zm.61 7.63A3 3 0 1116 12.52a3 3 0 01-1.61 3.12z"/>
</template>
